import { action } from "satcheljs";
import type { TableView } from "owa-mail-list-store";
import type { MailboxInfo } from "owa-client-types";

export interface OnReadingPanePopoutActionMessage {
    mailboxInfo: MailboxInfo;
    targetWindow: Window;
}

export const onReadingPanePopout: (mailboxInfo: MailboxInfo, targetWindow: Window) => OnReadingPanePopoutActionMessage = action("ON_READING_PANE_POPOUT", (mailboxInfo: MailboxInfo, targetWindow: Window): OnReadingPanePopoutActionMessage => ({
    mailboxInfo,
    targetWindow,
}));

/**
 * Called when the table has single selection, and user selects another single conversation
 * or another item part in the same conversation.
 * @param itemId the id of itemId which is going to be deselected
 * @param tableView the tableView where the single selection changed
 */
export interface ON_ITEM_PART_DESELECTEDActionMessage {
    itemId: string;
    tableView: TableView | undefined;
}
export const onItemPartDeselected: (itemId: string, tableView: TableView | undefined) => ON_ITEM_PART_DESELECTEDActionMessage = action("ON_ITEM_PART_DESELECTED", (itemId: string, tableView: TableView | undefined): ON_ITEM_PART_DESELECTEDActionMessage => ({
    itemId,
    tableView,
}));
